import React from 'react';
import ChampionsLayout from '../../components/layout/ChampionsLayout';
import QuestionBank from '../teacher/QuestionBank';

const ChampionsQuestionBankWrapper = () => (
  <ChampionsLayout>
    <QuestionBank
      role="champion"
      forceMine
      hideSelfOnlyToggle
      Layout={React.Fragment}
    />
  </ChampionsLayout>
);

export default ChampionsQuestionBankWrapper;
